import Cookies from 'js-cookie';

import {
  SUBSCRIBE_EMAIL_SECTION,
  SUBSCRIBE_EMAIL_SUCCESS,
  SUBSCRIBE_EMAIL_INPUT,
  SUBSCRIBE_EMAIL_BUTTON,
  SUBSCRIBE_EMAIL_FORM
} from '../classnames/email-subscription';

import BaseEmailSubscriptionHandler from './base-email-subscription-handler';
import ImagesVisibilityHandler from './images-visibility-handler';

export default class EmailSubscriptionHandler extends BaseEmailSubscriptionHandler {
  constructor(container) {
    super(
      container,
      SUBSCRIBE_EMAIL_FORM,
      SUBSCRIBE_EMAIL_SECTION,
      SUBSCRIBE_EMAIL_SUCCESS,
      SUBSCRIBE_EMAIL_BUTTON,
      SUBSCRIBE_EMAIL_INPUT
    );
    this.imagesVisibilityHandler = new ImagesVisibilityHandler();
  }

  cookie = 'subscribe-to-email';

  onSubmitSuccess() {
    super.onSubmitSuccess();

    Cookies.set(this.cookie, true);
  }

  initialize() {
    if (Cookies.get(this.cookie)) {
      this.container.remove();
      return;
    }

    super.initialize();
    this.imagesVisibilityHandler.initialize();
  }
}
